export default __webpack_public_path__ + "static/realWorldImg1-028c6b2bf00d7c37f1ec4648568599e2.png";